import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { MdClose } from "react-icons/md";
import { compose, withStateHandlers } from 'recompose';

const Tooltip = ({ disabled, tip, component, placement = 'top', resetTooltip, index }) => {
  const tooltip = <Popover id='tooltip' className='tooltip'>
    <span onClick={resetTooltip} style={{ float: "right", cursor: "pointer" }}><MdClose /></span>
    {tip}
  </Popover>

  const child = <div>{component}</div >

  const isLargeScreen = window.innerWidth > 1000

  return disabled ? child : <OverlayTrigger key={index} trigger={isLargeScreen ? ['hover', 'click'] : ['click']} rootClose placement={placement} overlay={tooltip}>
    {child}
  </OverlayTrigger>
}

export default compose(
  withStateHandlers(
    {
      index: 0
    },
    {
      resetTooltip: ({ index }) => () => ({
        index: index + 1
      })
    }
  )
)(Tooltip);


// WEBPACK FOOTER //
// ./src/containers/components/tooltip.js